import createPersistedState from 'vuex-persistedstate';

import userData from './modules/userData'
import company from './modules/company'
import filterOptions from './modules/filterOptions'

//initiliase store for Vuex
const store  = {
  plugins: [
    createPersistedState({})
  ],
  state : {
    filterUrl : '',
    updateData : 0
  },
  modules : {
    userData,
    company,
    filterOptions
  }
};

export default store;